import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, NavigationStart, Router, RouterStateSnapshot } from '@angular/router';
import { ConnectionService } from '../../shared/services/Connection/connection.service';
import { CacheService } from '../../shared/services/Cache/cache.service';
import { ApiService } from '../../shared/services/API/api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BottomMenuService } from '../../shared/services/bottom-Service/bottom-menu.service';
import { placeCounter, typeInterface } from 'src/app/shared/Interfaces/company';
import { CartService } from 'src/app/shared/services/Cart/cart.service';
import { OrderService } from 'src/app/shared/services/Order/order.service';
import { LogsService } from 'src/app/shared/services/logs.service';

@Injectable({
  providedIn: 'root',
})
export class verificationCacheGuard implements CanActivate {
  constructor(
    private router: Router,
    private connection: ConnectionService,
    private cacheService: CacheService,
    private apiService: ApiService,
    private bottomService: BottomMenuService,
    private cartService: CartService,
    private orderService: OrderService,
    private logsService: LogsService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const fullUrl = state.url;
    const [_, nameCompany, typeParam] = fullUrl.split('/');
    const qrCode = this.cacheService.getItemLocalTimeout('qrCode_key')
    const counter = this.cacheService.getItemLocalTimeout('counter_key');

    //Atualiza o nome da empresa
    this.connection.updateNameCompany(nameCompany)

    //Valida se existe cache do QrCode e o parametro sejá Mesa/Comanda
    if (typeParam === 'P') {
      if (!qrCode) {
        this.router.navigate(['/Authentication']);
        this.logsService.sendLogs("Qr Code Mesa Expirado", "warn");
        return false;
      }

      return this.handleLocalFlow(qrCode.data, nameCompany);
    }

    //Valida se existe cache do balcão e o parametro sejá Balcão
    if (!counter && typeParam === 'B') {
      this.router.navigate(['/Authentication']);
      this.logsService.sendLogs("Qr Code Balcão Expirado", "warn");
      return false;
    }

    //Constrói a inteface Balcão
    const type: typeInterface = {
      type: 3,
      qrCodeNumber: counter.data,
      numberParam: 0
    };

    this.connection.updateType(type);

    return this.handleCounterFlow(counter);

  }

  //Fluxo de Mesa e Comanda
  private handleLocalFlow(qrCode: string, nameCompany: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.apiService.getAuthentication(qrCode, nameCompany).subscribe(
        data => {
          const auth = data.response;
          const id_company = auth.id_company;
  
          const isComanda = auth.cardNumber !== 0;
          const number = isComanda ? auth.cardNumber : auth.tableNumber;
  
          //Verifica pedido nesta Mesa/Comanda
          this.apiService.getOrderConsumption(isComanda ? number : 0, isComanda ? 0 : number, id_company).subscribe(
            (response) => {
              if (!response.orderEmpty) {
                this.orderSucess(response);
              } else {
                this.orderEmpty();
              }
            },
            (error) => {
              this.router.navigate(['/Authentication'])
              this.logsService.sendLogs("Erro ao consultar pedido na mesa/comanda", "error", error);
            }
          );
  
          this.connection.updateRequestOrder((isComanda ? auth.cardStatus : auth.tableStatus) !== 20);
  
          const type: typeInterface = {
            type: isComanda ? 2 : 1,
            qrCodeNumber: qrCode,
            numberParam: number.toString()
          };

          this.connection.updateType(type);
  
          this.logsService.sendLogs("Mesa/Comanda acessada com sucesso", "sucess", qrCode);
          observer.next(true);
          observer.complete();
        },
        error => {
          console.error('Erro ao obter autenticação:', error);
          this.router.navigate(['/Authentication']);
          this.logsService.sendLogs("Erro ao obter autenticação", "error", error);
          observer.next(false);
          observer.complete();
        }
      );
    });
  };

  //Fluxo de Balcão
  private handleCounterFlow(counter: any): Observable<boolean> {
    return new Observable<boolean>((observer) => {

      //Valida se já não foi carregado
      if (this.orderService.currentPlace.id_place != '') {
        observer.next(true);
        observer.complete();
        return;
      }

      //Resgata a localização caso não exista
      this.apiService.getPlacesCounter(counter.data).subscribe(
      (data) =>{
        // ✅ Sem localização → pode seguir
        if (data.length === 0) {
          console.warn('Balcão sem localização, seguindo normalmente');
          // this.logsService.sendLogs("Balcão sem localização - acessado com sucesso", "sucess", counter.data);
          observer.next(true);
          observer.complete();
          return;
        }

        const placeData = data[0];

        // ❌ Localização inválida
        if (placeData.deleted === 1 || placeData.active === 0) {
          this.router.navigate(['/Authentication']);
          this.logsService.sendLogs("Balcão com localização inativa", "warn", counter.data);
          observer.next(false);
          observer.complete();
          return;
        }

        // ✅ Localização válida
        const place: placeCounter = {
          id_place: placeData.id_place,
          placeName: placeData.placeName
        };

        this.orderService.updatePlace(place);

        // this.logsService.sendLogs("Balcão acessado com sucesso", "sucess", counter.data);
        observer.next(true);
        observer.complete();

      },
      (error) =>{
        console.error('Erro ao validar localização', error);
        this.router.navigate(['/Authentication']);
        this.logsService.sendLogs("Erro ao buscar Localização balcão", "error", error);
        observer.next(false);
        observer.complete();

      });

    });
  }

  //Verificação para caso tenho pedido Mesa/Comanda
  private orderSucess(response: any){
    const order = response.response.orders[0]

    this.cacheService.setItemLocal('number_local', order.table)

    this.cartService.updateNameCustomer(order.customerName)

    this.bottomService.activeButtonWaiterSubject.next(false)

    if(response.response.orders.length == 1)
    {
      const session = this.cacheService.getItemLocal('session_id')

      if(session)
      {
        if(session != order.id_order)
        {
          this.router.navigate(['/Authentication']);
        }
      }
      else{
        this.cacheService.setItemLocal('session_id', order.id_order)
      }
    }
  }

  //Verificação para caso não tenha pedido Mesa/Comanda;
  private orderEmpty(){
    this.bottomService.activeButtonWaiterSubject.next(true)
    const session = this.cacheService.getItemLocal('session_id')
    if(session){
      this.router.navigate(['/Authentication']);
    }
  }
}
